module.exports = __webpack_public_path__ + "static/media/prenota.a97a3e52.svg";